<template>
  <div class="m-more">
    <van-cell-group inset title="业务入口">
      <van-cell title="年线偏离" is-link @click="$emit('navigate', 'ma-deviation')" />
      <van-cell title="模拟实盘" is-link @click="$emit('navigate', 'sim-trading')" />
      <van-cell title="策略回测" is-link @click="$emit('navigate', 'backtest')" />
      <van-cell title="策略预测" is-link @click="$emit('navigate', 'backtest-forecast')" />
      <van-cell title="神奇九转" is-link @click="$emit('navigate', 'td9')" />
      <van-cell title="日K查询" is-link @click="$emit('navigate', 'kline')" />
      <van-cell title="基金重仓" is-link @click="$emit('navigate', 'fund')" />
      <van-cell title="重仓行业" is-link @click="$emit('navigate', 'fund-industry')" />
      <van-cell title="行业行情" is-link @click="$emit('navigate', 'industry')" />
      <van-cell title="行业趋势" is-link @click="$emit('navigate', 'industry-trend')" />
      <van-cell title="个股趋势" is-link @click="$emit('navigate', 'stock-trend')" />
      <van-cell title="指数趋势" is-link @click="$emit('navigate', 'index-trend')" />
    </van-cell-group>

    <van-cell-group inset title="说明" class="gap">
      <van-cell
        title="电脑版完整功能"
        label="宽表、导出、用户管理等请用 PC 浏览器访问同一地址"
      />
      <van-cell
        title="强制切换"
        label="URL 加 ?device=pc 或 ?device=mobile 可强制指定端"
      />
    </van-cell-group>

    <div class="logout-wrap">
      <van-button block type="danger" plain hairline @click="$emit('logout')">退出登录</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMore',
}
</script>

<style scoped>
.m-more {
  padding: 12px 0 24px;
}
.gap {
  margin-top: 12px;
}
.logout-wrap {
  margin: 24px 16px 0;
}
</style>
